import RightMenu from '@components/RightMenu';
import React, { useEffect, useState } from 'react';
import styles from "./AccountReferral.module.scss"
import classNames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
import CopyIcon from '@components/svg/CopyIcon';
import imgBanner from "@assets/images/profilePage/banner-inner.png";
import { Image } from 'antd';
import { useQuery } from 'react-query';
import { getUserQuery } from 'dataLayer/user';
import BackIcon from '@components/svg/BackIcon';

const cx = classNames.bind(styles)
function AccountReferral({ setCurrentTab }) {
	const { data: user } = useQuery(getUserQuery());
	const dataReferral = {
		data: [
			{
				auction_time: "2023-03-20T05:58:01.000Z",
				image: null,
				isdn: "923****933",
				key: 0,
				name: "923****933",
				status: "Success"
			},
			{
				auction_time: "2023-03-20T05:58:01.000Z",
				image: null,
				isdn: "923****933",
				key: 0,
				name: "923****933",
				status: "Pending"
			},
			{
				auction_time: "2023-03-20T05:58:01.000Z",
				image: null,
				isdn: "923****933",
				key: 0,
				name: "923****933",
				status: "Rejected"
			},
		],
		pageSize: "10",
		success: true,
		total: 3,
	}
	const [showHelp, setShowHelp] = useState(false)
	const { t } = useTranslation();
	const handleHelp = () => {
		setShowHelp(true)
	}
	const closeHelp = () => {
		setShowHelp(false)

	}
	const [width, setWidth] = useState(window.innerWidth);

	function handleWindowSizeChange() {
		setWidth(window.innerWidth);
	}

	useEffect(() => {
		window.addEventListener("resize", handleWindowSizeChange);
		return () => {
			window.removeEventListener("resize", handleWindowSizeChange);
		};
	}, []);

	const isMobile = width <= 768;
	const isWebOneColumn = width <= 1200;


	return (
		<div className={cx('container', `${isWebOneColumn ? "web-one-column" : ''}`, `${isMobile ? 'mobile' : ''}`)}>
			<div >

				{showHelp ?
					(<div className={cx('box-help')}>
						<button onClick={closeHelp} className={cx("btn-back")}> <i><BackIcon /></i>Back</button>
						<p>
							Please sending a referral link or your referral code to your friends to join the subastas together and have 2 free bids
						</p>
						<div className={cx('content-help')}>
							<p>To receive free bids through referrals, users need to perform the following steps:</p>
							<p><h3>- step 1:</h3> The referrer chooses the Referral module {'->'} my Referral code </p>
							<p><h3>- step 2:</h3> Referrer Copy Referral Code or Referral Link to send to their relatives (Referral Code and Referral Link are unique and separate for each user) </p>
							<p><h3>	- step 3: For the referred:</h3></p>
							<p>+ In case the referred receives a Referral Code, the referred accesses the subastas website and registers to use the service. After completing the registration procedure, select the Introduction function module à Enter Referral Code. Here, the Referred enters the Referral Code that was sent previously.</p>
							<p>+ In case the referred receives a referral link, the referred clicks on the received link. The user will be redirected to the homepage of Subastas. The referred only needs to complete the registration procedure to receive the offer without entering the referral code as in case 1.</p>
							<p><h3>- Step 4: Received offers</h3></p>
							<p>The referrer will receive a notice on the website: You will receive 2 free bids from successfully referring subscribers [phone_number_1] participating in the program.</p>
							<p>At the same time, the referred will also receive the message: Welcome to our auction service. You will get 2 free bids thanks to the “Referral Offer” program</p>
						</div>
					</div>)
					: (
						<>
							<div className={cx('container-referral')}>
								<div className={cx('box-referral', `${isMobile ? 'mobile' : ''}`)}>
									<div className={cx('header-box_referral')}>
										{t('account.Referral_page.title_referral')}
									</div>
									<div className={cx('body-referral')}>
										<h3>{t('account.Referral_page.Referral_link')}</h3>
										<div className={cx('box-input')}><input disabled />  <span><CopyIcon /></span> </div>

										<h3>{t('account.Referral_code')}</h3>
										<div className={cx('box-input')}> <input value={user?.msisdn} disabled /> <span><CopyIcon /></span> </div>
										<a onClick={handleHelp}>{t('account.Referral_page.tutorial_link')}</a>
									</div>
								</div>
							</div>
							<div className={cx('container-referral')}>
								<div className={cx('box-referral', `${isMobile ? 'mobile' : ''}`)}>
									<div className={cx('header-box_referral')}>
										{t('account.Referral_page.title_enter_referral')}
									</div>
									<div className={cx('body-enter_referral')}>
										<div className={cx('banner')}>
											<Image preview={false} src={imgBanner} />
										</div>
										<p className={cx('decription')}>Enter the phone number of your referrer to both both get 2 free bids from our service</p>
										<input className={cx(`${isMobile ? 'mobile' : ''}`)} placeholder={t("account.Referral_page.placeholder")} />
										<button>{t('account.Referral_page.submit')}</button>
									</div>
								</div>
							</div>
						</>
					)}

			</div>
			<RightMenu type="AccountReferral" dataReferral={dataReferral} />
		</div>
	);
}

export default AccountReferral;